import { Pipe, PipeTransform } from '@angular/core';
import { DateFormat } from '../utils/date-format';

@Pipe({
  name: 'localDateTime'
})
export class LocalDateTimePipe implements PipeTransform {
  constructor(private dateFormat: DateFormat) { }
  transform(value: any): any {
    if (!value || value === '') {
      return '';
    }
    try {
      // As per requirement seconds should be excluded, refer => https://epm.verisk.com/jira/browse/ISPCOR-160
      return this.dateFormat.format(value, 'MM/dd/yyyy HH:mm');
    } catch {
      return '';
    }
  }
}
